import warningMessagesTitlesDo from "../../../../src/pages/foundations/content/designing-messages/warning-messages/_assets/warning-messages-titles-do.png";
import warningMessagesTitlesDont from "../../../../src/pages/foundations/content/designing-messages/warning-messages/_assets/warning-messages-titles-dont.png";
import warningMessagesBodyDo from "../../../../src/pages/foundations/content/designing-messages/warning-messages/_assets/warning-messages-body-do.png";
import warningMessagesBodyDont from "../../../../src/pages/foundations/content/designing-messages/warning-messages/_assets/warning-messages-body-dont.png";
import warningMessagesAwarenessDo from "../../../../src/pages/foundations/content/designing-messages/warning-messages/_assets/warning-messages-awareness-do.png";
import warningMessagesAwarenessDont from "../../../../src/pages/foundations/content/designing-messages/warning-messages/_assets/warning-messages-awareness-dont.png";
import warningMessagesConfirmDo from "../../../../src/pages/foundations/content/designing-messages/warning-messages/_assets/warning-messages-confirm-do.png";
import warningMessagesConfirmDont from "../../../../src/pages/foundations/content/designing-messages/warning-messages/_assets/warning-messages-confirm-dont.png";
import * as React from 'react';
export default {
  warningMessagesTitlesDo,
  warningMessagesTitlesDont,
  warningMessagesBodyDo,
  warningMessagesBodyDont,
  warningMessagesAwarenessDo,
  warningMessagesAwarenessDont,
  warningMessagesConfirmDo,
  warningMessagesConfirmDont,
  React
};